module.exports = __webpack_public_path__ + "media/images/login_before_img_sp-491e2558458c02075fdcca5d7b6b435d.png";